import { ENV } from "../utils";

export class Ocupacion {
  baseApi = ENV.BASE_API;

  async getOcupaciones(accessToken, active = true) {
    const url = `${this.baseApi}/occupations?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createOcupacion(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-occupation`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateOcupacion(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-occupation/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteOcupacion(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-occupation/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
